module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/Last-Stand-of-the-300-3.79ea82d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/Last-Stand-of-the-300-3.jpg
// module id = hKzz
// module chunks = 0